import React, { useContext } from 'react'
import { PanelStyleContext } from './PanelStyleContext'

const ExpandedOverlay = ({ children }) => {
    const { isExpanded } = useContext(PanelStyleContext)

    return (
        <div className={`${isExpanded ? 'fullscreen-overlay' : ''}`}>
            {children}
        </div>
    )
}

export default ExpandedOverlay